import classNames from 'classnames';
import { camelCase, upperFirst } from 'lodash-es';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import Tag from '../../../common/tags/Tag';

import css from './MerchantTag.module.scss';

interface Props {
  className?: string;
  status: string;
}

const MerchantTag = ({
  className,
  intl,
  status,
}: Props & InjectedIntlProps) => {
  const classes = (courseStatus: string) =>
    classNames(
      css.MerchantTag,
      css[`is${upperFirst(camelCase(courseStatus))}`],
      className,
    );

  return (
    <Tag className={classes(status)}>
      {intl.formatMessage({
        id: `merchants.bookingPages.status.${camelCase(status)}`,
      })}
    </Tag>
  );
};

export default injectIntl(MerchantTag);
